import React, { useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import RotateDeviceIcon from './rotate_device_icon.svg?react';
import { useIntl } from 'react-intl';
import Title from 'ui/Typography/Title';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums/lib';
import useDeviceOrientation from 'hooks/useDeviceOrientation';

const rotateAnimation = keyframes`
  from {
    transform: rotate(45deg);
  }

  to {
    transform: rotate(135deg);
  }
`;

const RotateDeviceBadge = styled(RotateDeviceIcon)`
  background-color: ${({ theme }) => theme.colors.yellow};
  padding: 1rem;
  box-sizing: content-box;
  border-radius: 50%;
  margin-bottom: ${({ theme }) => theme.space.md};
  animation-name: ${rotateAnimation};
  animation-iteration-count: infinite;
  animation-duration: 1s;
  animation-direction: alternate-reverse;
  animation-timing-function: linear;
`;

const ChangeOrientationMessage = styled.div`
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
`;

const RotateDevice = () => {
  const { formatMessage } = useIntl();
  const deviceOrientation = useDeviceOrientation();

  useEffect(() => {
    // @ts-ignore
    // lock screen to portrait mode if device and browser supports it
    // @see https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation/lock
    if (typeof window.screen?.orientation?.lock === 'function') {
      // @ts-ignore
      // suppress any not supported errors
      window.screen.orientation.lock('portrait-primary').catch(() => null);
    }
  }, []);

  if (deviceOrientation.inPortraitMode) return <></>;

  return (
    <ChangeOrientationMessage>
      <RotateDeviceBadge />
      <Title type={ThemeFontStyleTypeEnum.headingMedium}>
        {formatMessage({ id: 'storageone.mobileRotateDevice' })}
      </Title>
    </ChangeOrientationMessage>
  );
};

export default RotateDevice;
